module.exports = __webpack_public_path__ + "static/media/b99-post-bot.655d4bc5.png";